import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useDispatch } from "react-redux";
import { editTrackState } from "../Redux/TrackSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <img src="/images/Home/close_img.png" alt="close icon" className="form_close_img" />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}
BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    "&:hover": {
        backgroundColor: "#7500C0",
        color: "#fff",
    },
}));

function EditConfirmationPopup({ openConfirmation, setOpenConfirmation, details, onCancel }) {
    const dispatch = useDispatch();

    const handleClose = () => {
        setOpenConfirmation(false);
        if (onCancel) onCancel();
    };

    const saveEditHandle = () => {
        dispatch(editTrackState(details?.id, details?.state));
        setOpenConfirmation(false);
    };

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openConfirmation}
            maxWidth="sm"
            fullWidth
        >
            <BootstrapDialogTitle
                id="customized-dialog-title"
                sx={{
                    fontSize: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                    paddingBottom: "0px !important",
                }}
                onClose={handleClose}
            >
                Confirmation
            </BootstrapDialogTitle>

            <DialogContent sx={{ paddingTop: "15px" }}>
                <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
                    <Typography>
                        Are you sure you want to change the state of{" "}
                        <strong>{details?.track}</strong> to{" "}
                        <strong>{details?.state ? "Active" : "Inactive"}</strong>?
                    </Typography>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
                <ColorButton
                    variant="contained"
                    size="small"
                    sx={{
                        background: "white",
                        color: "#7500C0",
                        border: "solid 1px #7500C0",
                    }}
                    onClick={handleClose}
                >
                    Cancel
                </ColorButton>

                <ColorButton
                    variant="contained"
                    size="small"
                    sx={{ background: "#7500C0", color: "white" }}
                    onClick={saveEditHandle}
                >
                    Yes
                </ColorButton>
            </DialogActions>
        </BootstrapDialog>
    );
}

EditConfirmationPopup.propTypes = {
    openConfirmation: PropTypes.bool.isRequired,
    setOpenConfirmation: PropTypes.func.isRequired,
    details: PropTypes.shape({
        id: PropTypes.any,
        track: PropTypes.string,
        state: PropTypes.bool,
    }),
    onCancel: PropTypes.func,
};

export default EditConfirmationPopup;
